/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CounselorDutyPreferencesResponse,
  CounselorPresenceResponse,
  CounselorResponse,
  CounselorWorkTimeResponse,
  ProblemDetails,
  SaveCounselorDutyPreferencesRequest,
  SaveCounselorPersonalDataRequest,
  SaveCounselorWorkTimeRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CounselorDutyPreferencesResponseFromJSON,
    CounselorDutyPreferencesResponseToJSON,
    CounselorPresenceResponseFromJSON,
    CounselorPresenceResponseToJSON,
    CounselorResponseFromJSON,
    CounselorResponseToJSON,
    CounselorWorkTimeResponseFromJSON,
    CounselorWorkTimeResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SaveCounselorDutyPreferencesRequestFromJSON,
    SaveCounselorDutyPreferencesRequestToJSON,
    SaveCounselorPersonalDataRequestFromJSON,
    SaveCounselorPersonalDataRequestToJSON,
    SaveCounselorWorkTimeRequestFromJSON,
    SaveCounselorWorkTimeRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface GetCounselorDutyPreferencesRequest {
    id: string;
}

export interface GetCounselorPresenceRequest {
    id: string;
}

export interface GetCounselorWorkTimeRequest {
    id: string;
}

export interface SaveCounselorDutyPreferencesOperationRequest {
    id: string;
    saveCounselorDutyPreferencesRequest: SaveCounselorDutyPreferencesRequest;
}

export interface SaveCounselorPersonalDataOperationRequest {
    id: string;
    saveCounselorPersonalDataRequest: SaveCounselorPersonalDataRequest;
}

export interface SaveCounselorWorkTimeOperationRequest {
    id: string;
    saveCounselorWorkTimeRequest: SaveCounselorWorkTimeRequest;
}

/**
 * CounselorsApi - interface
 * 
 * @export
 * @interface CounselorsApiInterface
 */
export interface CounselorsApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorsApiInterface
     */
    getAllCounselorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CounselorResponse>>>;

    /**
     */
    getAllCounselors(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CounselorResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorsApiInterface
     */
    getCounselorDutyPreferencesRaw(requestParameters: GetCounselorDutyPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorDutyPreferencesResponse>>;

    /**
     */
    getCounselorDutyPreferences(requestParameters: GetCounselorDutyPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorDutyPreferencesResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorsApiInterface
     */
    getCounselorPresenceRaw(requestParameters: GetCounselorPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorPresenceResponse>>;

    /**
     */
    getCounselorPresence(requestParameters: GetCounselorPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorPresenceResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorsApiInterface
     */
    getCounselorWorkTimeRaw(requestParameters: GetCounselorWorkTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorWorkTimeResponse>>;

    /**
     */
    getCounselorWorkTime(requestParameters: GetCounselorWorkTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorWorkTimeResponse>;

    /**
     * 
     * @param {string} id 
     * @param {SaveCounselorDutyPreferencesRequest} saveCounselorDutyPreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorsApiInterface
     */
    saveCounselorDutyPreferencesRaw(requestParameters: SaveCounselorDutyPreferencesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorDutyPreferencesResponse>>;

    /**
     */
    saveCounselorDutyPreferences(requestParameters: SaveCounselorDutyPreferencesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorDutyPreferencesResponse>;

    /**
     * 
     * @param {string} id 
     * @param {SaveCounselorPersonalDataRequest} saveCounselorPersonalDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorsApiInterface
     */
    saveCounselorPersonalDataRaw(requestParameters: SaveCounselorPersonalDataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorResponse>>;

    /**
     */
    saveCounselorPersonalData(requestParameters: SaveCounselorPersonalDataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorResponse>;

    /**
     * 
     * @param {string} id 
     * @param {SaveCounselorWorkTimeRequest} saveCounselorWorkTimeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounselorsApiInterface
     */
    saveCounselorWorkTimeRaw(requestParameters: SaveCounselorWorkTimeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorWorkTimeResponse>>;

    /**
     */
    saveCounselorWorkTime(requestParameters: SaveCounselorWorkTimeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorWorkTimeResponse>;

}

/**
 * 
 */
export class CounselorsApi extends runtime.BaseAPI implements CounselorsApiInterface {

    /**
     */
    async getAllCounselorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CounselorResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselors`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CounselorResponseFromJSON));
    }

    /**
     */
    async getAllCounselors(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CounselorResponse>> {
        const response = await this.getAllCounselorsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCounselorDutyPreferencesRaw(requestParameters: GetCounselorDutyPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorDutyPreferencesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCounselorDutyPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselors/{id}/duty-preferences`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CounselorDutyPreferencesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCounselorDutyPreferences(requestParameters: GetCounselorDutyPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorDutyPreferencesResponse> {
        const response = await this.getCounselorDutyPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCounselorPresenceRaw(requestParameters: GetCounselorPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorPresenceResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCounselorPresence().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselors/{id}/presence`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CounselorPresenceResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCounselorPresence(requestParameters: GetCounselorPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorPresenceResponse> {
        const response = await this.getCounselorPresenceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCounselorWorkTimeRaw(requestParameters: GetCounselorWorkTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorWorkTimeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCounselorWorkTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/counselors/{id}/work-time`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CounselorWorkTimeResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCounselorWorkTime(requestParameters: GetCounselorWorkTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorWorkTimeResponse> {
        const response = await this.getCounselorWorkTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveCounselorDutyPreferencesRaw(requestParameters: SaveCounselorDutyPreferencesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorDutyPreferencesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling saveCounselorDutyPreferences().'
            );
        }

        if (requestParameters['saveCounselorDutyPreferencesRequest'] == null) {
            throw new runtime.RequiredError(
                'saveCounselorDutyPreferencesRequest',
                'Required parameter "saveCounselorDutyPreferencesRequest" was null or undefined when calling saveCounselorDutyPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/counselors/{id}/duty-preferences`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveCounselorDutyPreferencesRequestToJSON(requestParameters['saveCounselorDutyPreferencesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CounselorDutyPreferencesResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveCounselorDutyPreferences(requestParameters: SaveCounselorDutyPreferencesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorDutyPreferencesResponse> {
        const response = await this.saveCounselorDutyPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveCounselorPersonalDataRaw(requestParameters: SaveCounselorPersonalDataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling saveCounselorPersonalData().'
            );
        }

        if (requestParameters['saveCounselorPersonalDataRequest'] == null) {
            throw new runtime.RequiredError(
                'saveCounselorPersonalDataRequest',
                'Required parameter "saveCounselorPersonalDataRequest" was null or undefined when calling saveCounselorPersonalData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/counselors/{id}/personal-data`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveCounselorPersonalDataRequestToJSON(requestParameters['saveCounselorPersonalDataRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CounselorResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveCounselorPersonalData(requestParameters: SaveCounselorPersonalDataOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorResponse> {
        const response = await this.saveCounselorPersonalDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveCounselorWorkTimeRaw(requestParameters: SaveCounselorWorkTimeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CounselorWorkTimeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling saveCounselorWorkTime().'
            );
        }

        if (requestParameters['saveCounselorWorkTimeRequest'] == null) {
            throw new runtime.RequiredError(
                'saveCounselorWorkTimeRequest',
                'Required parameter "saveCounselorWorkTimeRequest" was null or undefined when calling saveCounselorWorkTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/counselors/{id}/work-time`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveCounselorWorkTimeRequestToJSON(requestParameters['saveCounselorWorkTimeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CounselorWorkTimeResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveCounselorWorkTime(requestParameters: SaveCounselorWorkTimeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CounselorWorkTimeResponse> {
        const response = await this.saveCounselorWorkTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
